function _0xc878() {
  const _0x6ebfbd = [
    "buildUrl",
    "126LwdECD",
    "fetchProducts",
    "2416912uGyAOL",
    "205730EBewhU",
    "products",
    "length",
    "define",
    "max",
    "138641eeOdnI",
    "get",
    "text",
    "localStorage",
    "createElement",
    "\x20OR\x20",
    "routes",
    "div",
    "1463444FlRfUx",
    "recently-viewed-products",
    "product-recommendations--loaded",
    "recentlyViewedIds",
    "querySelector",
    "825756TTDzRB",
    "container",
    "innerHTML",
    "12ZgQyiZ",
    "currentId",
    "url",
    "add",
    "recently-viewed",
    "handle:",
    "error",
    "?view=recently-viewed&type=product&q=",
    "1468838KRXDSo",
    ".products",
    "then",
    "5AUHwnZ",
    "search_url",
    "trim",
    "classList",
    "164396BceHqS",
    "productHandle",
    "parse",
    "catch",
    "dataset",
  ];
  _0xc878 = function () {
    return _0x6ebfbd;
  };
  return _0xc878();
}
function _0x15f6(_0x31d5a5, _0x4b2c7b) {
  const _0xc87895 = _0xc878();
  return (
    (_0x15f6 = function (_0x15f687, _0x187f4e) {
      _0x15f687 = _0x15f687 - 0x1b7;
      let _0x411946 = _0xc87895[_0x15f687];
      return _0x411946;
    }),
    _0x15f6(_0x31d5a5, _0x4b2c7b)
  );
}
const _0xb1d717 = _0x15f6;
(function (_0x3e2014, _0x39ca67) {
  const _0x3b04a5 = _0x15f6,
    _0x135692 = _0x3e2014();
  while (!![]) {
    try {
      const _0x3a27f9 =
        -parseInt(_0x3b04a5(0x1c6)) / 0x1 +
        (-parseInt(_0x3b04a5(0x1b8)) / 0x2) * (-parseInt(_0x3b04a5(0x1d6)) / 0x3) +
        parseInt(_0x3b04a5(0x1ce)) / 0x4 +
        (-parseInt(_0x3b04a5(0x1e1)) / 0x5) * (parseInt(_0x3b04a5(0x1d3)) / 0x6) +
        -parseInt(_0x3b04a5(0x1de)) / 0x7 +
        -parseInt(_0x3b04a5(0x1c0)) / 0x8 +
        (parseInt(_0x3b04a5(0x1be)) / 0x9) * (parseInt(_0x3b04a5(0x1c1)) / 0xa);
      if (_0x3a27f9 === _0x39ca67) break;
      else _0x135692["push"](_0x135692["shift"]());
    } catch (_0x4a4346) {
      _0x135692["push"](_0x135692["shift"]());
    }
  }
})(_0xc878, 0x2f79c);
if (!customElements[_0xb1d717(0x1c7)](_0xb1d717(0x1cf))) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      const _0x4e8c3b = _0xb1d717;
      super(),
        (this[_0x4e8c3b(0x1d8)] = theme[_0x4e8c3b(0x1cc)][_0x4e8c3b(0x1e2)] + _0x4e8c3b(0x1dd)),
        (this[_0x4e8c3b(0x1d4)] = this[_0x4e8c3b(0x1d2)](_0x4e8c3b(0x1df))),
        (this[_0x4e8c3b(0x1d7)] = this[_0x4e8c3b(0x1bc)][_0x4e8c3b(0x1b9)]),
        (this[_0x4e8c3b(0x1c5)] = 0x4),
        (this["products"] = "");
      if (window[_0x4e8c3b(0x1c9)]) {
        let _0x1c88ec = window[_0x4e8c3b(0x1c9)]["getItem"](_0x4e8c3b(0x1da));
        _0x1c88ec && typeof _0x1c88ec !== undefined && (window[_0x4e8c3b(0x1d1)] = JSON[_0x4e8c3b(0x1ba)](_0x1c88ec));
      }
    }
    ["connectedCallback"]() {
      const _0x3ab223 = _0xb1d717;
      this[_0x3ab223(0x1bd)]();
    }
    ["buildUrl"]() {
      const _0x49b070 = _0xb1d717;
      let _0x158f1e = 0x0;
      window[_0x49b070(0x1d1)]["forEach"]((_0x2abfcd) => {
        const _0xd04dcc = _0x49b070;
        if (_0x2abfcd === this[_0xd04dcc(0x1d7)]) return;
        if (_0x158f1e >= this[_0xd04dcc(0x1c5)]) return;
        (this[_0xd04dcc(0x1c2)] += _0xd04dcc(0x1db) + _0x2abfcd + _0xd04dcc(0x1cb)), _0x158f1e++;
      }),
        (this[_0x49b070(0x1d8)] = this[_0x49b070(0x1d8)] + encodeURIComponent(this[_0x49b070(0x1c2)])),
        this[_0x49b070(0x1bf)]();
    }
    [_0xb1d717(0x1bf)]() {
      const _0x226287 = _0xb1d717;
      fetch(this[_0x226287(0x1d8)])
        [_0x226287(0x1e0)]((_0x39cfef) => _0x39cfef[_0x226287(0x1c8)]())
        ["then"]((_0x36068b) => {
          const _0x4b5716 = _0x226287,
            _0x4ef8c5 = document[_0x4b5716(0x1ca)](_0x4b5716(0x1cd));
          _0x4ef8c5[_0x4b5716(0x1d5)] = _0x36068b;
          const _0x5e0574 = _0x4ef8c5[_0x4b5716(0x1d2)](_0x4b5716(0x1df));
          _0x5e0574 &&
            _0x5e0574[_0x4b5716(0x1d5)][_0x4b5716(0x1e3)]()[_0x4b5716(0x1c3)] &&
            ((this["container"]["innerHTML"] = _0x5e0574[_0x4b5716(0x1d5)]),
            this[_0x4b5716(0x1b7)][_0x4b5716(0x1d9)](_0x4b5716(0x1d0)));
        })
        [_0x226287(0x1bb)]((_0x3bacd1) => {
          const _0x36fb07 = _0x226287;
          console[_0x36fb07(0x1dc)](_0x3bacd1);
        });
    }
  }
  customElements[_0xb1d717(0x1c4)](_0xb1d717(0x1cf), RecentlyViewedProducts);
}
